<logged-in-user-menu [forceNotifButton]="true">
    <a class="notifications-link" mat-menu-item routerLink="/billing/upgrade" *ngIf="settings.get('billing.enable') && !currentUser.isSubscribed()" (click)="loggedInUserMenu.onItemClick()">
        <mat-icon svgIcon="star"></mat-icon>
        <span trans>Try Pro</span>
    </a>
</logged-in-user-menu>
